import { Injectable, inject } from '@angular/core';
import {
  CollaboratorQuestionairResponse,
  CollaboratorRoutesPreferencesResponse,
  FindCollaboratorQuestionairQuery,
  FindCollaboratorQuestionairQueryHandler,
  SearchCollaboratorRoutesPreferencesQuery,
  SearchCollaboratorRoutesPreferencesQueryHandler,
} from '@okcargo/query-processor';
import { BaseQueryRepository } from '@okcargo-apps/shared-infrastructure';

@Injectable({
  providedIn: 'root',
})
export class CollaboratorPreferencesQueryService {
  private readonly queryRepository = inject(BaseQueryRepository);

  private readonly findCollaboratorQuestionairQueryHandler: FindCollaboratorQuestionairQueryHandler;
  private readonly searchCollaboratorRoutesPreferencesQueryHandler: SearchCollaboratorRoutesPreferencesQueryHandler;

  constructor() {
    const queryRepository = this.queryRepository;

    this.findCollaboratorQuestionairQueryHandler = new FindCollaboratorQuestionairQueryHandler(queryRepository);
    this.searchCollaboratorRoutesPreferencesQueryHandler = new SearchCollaboratorRoutesPreferencesQueryHandler(
      queryRepository,
    );
  }

  public findCollaboratorQuestionair(
    query: FindCollaboratorQuestionairQuery,
  ): Promise<CollaboratorQuestionairResponse> {
    return this.findCollaboratorQuestionairQueryHandler.handle(query);
  }

  public searchCollaboratorRoutesPreferences(
    query: SearchCollaboratorRoutesPreferencesQuery,
  ): Promise<CollaboratorRoutesPreferencesResponse[]> {
    return this.searchCollaboratorRoutesPreferencesQueryHandler.handle(query);
  }
}
